import apiClient from "./api-client.service";
import { InterviewSession, MatchResult, Question } from "../Interface/Index";
import { InterviewSchedule } from "../Entities/interview-schedule.entity";

export default class InterviewService {
  public static Events = {
    QUESTIONS_GENERATED: "questions_generated",
  };

  public session: InterviewSession[] = [];
  public questions: Question[] = [];
  public sessionQuestions: Question[] = [];
  private static instance: InterviewService;
  private APIBaseUrl: string = "";

  constructor() {
    if (InterviewService.instance) {
      return InterviewService.instance;
    }
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async createInterviewSession(applicationId: string) {
    try {
      const formData = new FormData();
      formData.append("job_application_id", applicationId);
      const response = await apiClient.post(
        `${this.APIBaseUrl}/interview`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data;
      this.session = data;
      return data;
    } catch (error) {
      console.log("Error while creating session", error);
    }
  }

  async updateInterviewSession(
    sessionId: string,
    roundId: string,
    roundNumber: number
  ) {
    try {
      const response = await apiClient.put(
        `${this.APIBaseUrl}/interview/update/${sessionId}/${roundId}/${roundNumber}`
      );
      const data = response.data;
      return data;
    } catch (error) {
      console.log("Error while updating interview session", error);
    }
  }

  async generateQuestions(sessionId: string) {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/interview/${sessionId}/questions`
      );
      const data = response.data;
      return data;
    } catch (error) {
      console.log("Error while genarting questions", error);
    }
  }

  updateQuestionInSessionQuestions = (question: Question) => {
    const index = this.sessionQuestions.findIndex(
      (q) => q._id === question._id
    );
    if (index !== -1) {
      this.sessionQuestions[index] = question;
    } else {
      this.sessionQuestions.push(question);
    }
  };

  getSessionQuestions = async (sessionId: string) => {
    if (!this.sessionQuestions.length) {
      await this.getQuestionsBySessionId(sessionId);
    }
    return this.sessionQuestions;
  };

  async answerSingleQuestion(
    answer: string,
    sessionId: string,
    questionId: string
  ) {
    const formData = new FormData();
    formData.append("answer", answer);
    const response = await apiClient.put(
      `${this.APIBaseUrl}/interview/${sessionId}/questions/${questionId}/response`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("🚀 ~ InterviewService ~ response:", response);
    const data = response.data;
    this.updateQuestionInSessionQuestions(data);
    return data;
  }

  async getScanResults(jobApplicationId: string): Promise<MatchResult> {
    const response = await apiClient.get(
      `${this.APIBaseUrl}/profile-matcher/match/${jobApplicationId}`
    );
    const data = response.data[0];
    return data;
  }

  async getAvailableInterviewSlots(jobPostId: string) {
    const params = {
      jobPostId: jobPostId,
    };
    const queryString = new URLSearchParams(params).toString();
    const response = await apiClient(
      `${this.APIBaseUrl}/interview/free/slots?${queryString}`
    );
    // const today = new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
    // const todayInCandidateTimezone = new Date(today);
    // const timeZone = 'Asia/Kolkata';
    const data = response.data.map((slot: any) => {
      console.log("🚀 ~ getAvailableInterviewSlots ~ slot:", slot);
      const localStart = new Date(slot.start).toLocaleString("en-US");
      const localEnd = new Date(slot.end).toLocaleString("en-US");
      //     const localStart = new Date(slot.start).toLocaleString('en-US', {
      // timeZone: 'America/New_York'});
      //     const localEnd = new Date(slot.end).toLocaleString('en-US', {
      // timeZone: 'America/New_York'});
      // slot.start = slot.start.replace("Z", "");
      // slot.end = slot.end.replace("Z", "");
      slot.start = localStart;
      console.log("🚀 ~ InterviewService ~ data ~ localStart:", localStart);
      slot.end = localEnd;
      console.log("🚀 ~ InterviewService ~ data ~ localEnd:", localEnd);
      return slot;
    });
    console.log("Free slots are", data);
    return data;
  }

  async bookInterviewSlot(
    applicationId: string,
    startTime: string,
    endTime: string
  ) {
    const formData = new FormData();
    formData.append("job_application_id", applicationId);
    formData.append("start", startTime);
    formData.append("end", endTime);
    const response = await apiClient.post(
      `${this.APIBaseUrl}/interview/schedule`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = response.data;
    return data;
  }

  async finishExam(sessionId: string) {
    const response = await apiClient.post(
      `${this.APIBaseUrl}/interview/${sessionId}/evaluate`
    );
    return response.data;
  }

  async getAllInterviewSessionById(
    jobApplicationId: string
  ): Promise<InterviewSession[] | undefined> {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/interview?job_application_id=${jobApplicationId}`
      );
      const data = response.data;
      if (data.length > 0) {
        return data;
      }
    } catch (error) {
      console.error("Error fetching interview sessions:", error);
    }
  }

  async getInterviewSessionsByActiveId(jobApplicationId: string) {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/interview/active?job_application_id=${jobApplicationId}`
      );
      const data = response.data;
      return data?.length ? data[0] : data;
    } catch (error) {
      console.error("Error fetching interview sessions:", error);
    }
  }

  async getQuestionsBySessionId(sessionId: string): Promise<Question[]> {
    const response = await apiClient.get(
      `${this.APIBaseUrl}/interview/${sessionId}/questions`
    );
    const data = response.data;
    this.sessionQuestions = data;
    return data;
  }

  async getOnlineInterviewDetails(
    applicationId: string
  ): Promise<InterviewSchedule[]> {
    const response = await apiClient.get<InterviewSchedule[]>(
      `${this.APIBaseUrl}/interview/schedule/${applicationId}`
    );
    const data = response.data;
    return data;
  }

  async checkForMeetingLink(applicationId: string): Promise<boolean> {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/interview/check/link/${applicationId}`
      );
      return response.data;
    } catch (error) {
      console.error(
        "🚀 ~ InterviewService ~ checkForMeetingLink ~ error:",
        error
      );
      return false;
    }
  }

  async findSessionById(sessionId: string): Promise<InterviewSession | null> {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/interview/${sessionId}`
      );
      return response.data;
    } catch (error: any) {
      console.error("🚀 ~ InterviewService ~ findSessionById ~ error:", error);
      return null;
    }
  }
}
